import { FieldHookConfig, useField } from 'formik';
import { isEmpty } from 'src/utils/typeCheck';

import { TextField, TextFieldProps } from '../../../components/TextField';
interface FormTextFieldExtraProps {
  name: string; // Use 'name' to align with useField expected field name
}

type FormTextFieldProps = TextFieldProps &
  FormTextFieldExtraProps &
  FieldHookConfig<string>;

export const FormTextField: React.FC<FormTextFieldProps> = (props) => {
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;
  const { onChange } = props;

  return (
    <TextField
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
      {...field}
      value={isEmpty(field.value) ? '' : field.value}
      {...props}
      onChange={(event) => {
        setValue(event.target.value);
        if (onChange) onChange(event);
      }}
    />
  );
};
